export const FAVICON_URL =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg";

const RAW_SITE_URL: string | undefined = import.meta.env.VITE_SITE_URL;
export const SITE_ORIGIN = (RAW_SITE_URL || "").replace(/\/+$/, "");

const DATE_PUBLISHED = "2026-06-01";
const DATE_MODIFIED = "2026-08-23";

export function buildWebsiteSchema(lang: string) {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "USFans Spreadsheet",
    url: `${SITE_ORIGIN}/${lang}/`,
    inLanguage: lang,
  };
}

export function buildOrganizationSchema(lang: string) {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "USFans Spreadsheet",
    url: `${SITE_ORIGIN}/${lang}/`,
    logo: FAVICON_URL,
  };
}

export function buildArticleSchema(params: {
  lang: string;
  path: string;
  headline: string;
  description: string;
  image?: string;
}) {
  const url = `${SITE_ORIGIN}${params.path}`;

  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: params.headline,
    description: params.description,
    ...(params.image ? { image: params.image } : {}),
    author: { "@type": "Organization", name: "USFans Spreadsheet" },
    publisher: {
      "@type": "Organization",
      name: "USFans Spreadsheet",
      logo: { "@type": "ImageObject", url: FAVICON_URL },
    },
    datePublished: DATE_PUBLISHED,
    dateModified: DATE_MODIFIED,
    mainEntityOfPage: url,
    inLanguage: params.lang,
  };
}

export function buildBreadcrumbSchema(params: {
  lang: string;
  path: string;
  name: string;
  homeLabel: string;
}) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: params.homeLabel,
        item: `${SITE_ORIGIN}/${params.lang}/`,
      },
      {
        "@type": "ListItem",
        position: 2,
        name: params.name,
        item: `${SITE_ORIGIN}${params.path}`,
      },
    ],
  };
}